import FuseUtils from '@fuse/utils';
import authConfig from 'app/auth/authConfig';
import RoutesConfig from 'app/main';
import React from 'react';
import { Redirect } from 'react-router-dom';

const routeConfigs = [...RoutesConfig, ...authConfig];

const prodRoutes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, ['admin', 'staff', 'user']),
  {
    path: '/',
    component: () => <Redirect to="/visao-geral" />,
  },
  {
    component: () => <Redirect to="/visao-geral" />,
  },
];

const devRoutes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, ['user']),
  {
    path: '/',
    component: () => <Redirect to="/visao-geral" />,
  },
  {
    component: () => <Redirect to="/visao-geral" />,
  },
];

const routes = process.env.REACT_APP_ENABLE_AUTH === 'true' ? prodRoutes : devRoutes;

export default routes;
